import type {ChannelToggle} from '@api/notifications';
import {cn} from '@lib/utils';
import {NOTIFICATION_CHANNELS} from '@ui/local/notification-channels';
import {Button} from '@ui/shadcn/button';

/** Общий выбор каналов доставки: подключение не меняет сохранённый выбор. */
export const ChannelToggleGroup = ({
  value,
  connected,
  disabled = false,
  label,
  onChange,
}: {
  value: ChannelToggle;
  connected: ChannelToggle;
  disabled?: boolean;
  label: string;
  onChange: (value: ChannelToggle) => void;
}) => (
  <div
    role='group'
    aria-label={`Каналы доставки: ${label}`}
    className='flex flex-wrap gap-2'
  >
    {NOTIFICATION_CHANNELS.map((channel) => (
      <Button
        key={channel.name}
        type='button'
        size='xs'
        variant='outline'
        aria-label={`${channel.label}: ${label}`}
        aria-pressed={value[channel.name]}
        title={
          !connected[channel.name]
            ? `Сначала подключите ${channel.label} в каналах доставки`
            : undefined
        }
        disabled={disabled || !connected[channel.name]}
        className={cn(
          'h-8 px-2.5',
          value[channel.name] &&
            connected[channel.name] &&
            'border-[var(--color-primary)]/30 bg-[var(--color-primary-soft)] text-[var(--color-primary)] hover:bg-[var(--color-primary-soft)]',
        )}
        onClick={() =>
          onChange({...value, [channel.name]: !value[channel.name]})
        }
      >
        {channel.icon(12)} {channel.label}
      </Button>
    ))}
  </div>
);
